import React from 'react';
import { Link, useLocation, useParams, Navigate } from 'react-router-dom';
import { companyJobs } from '../../../data/companyJobs';

const hasItems = (arr) => Array.isArray(arr) && arr.length > 0;

const BulletList = ({ items }) => (
    <ul className="list-disc list-outside ml-6 space-y-2 text-neutral-200">
        {items.map((item, index) => (
            <li key={index}>{item}</li>
        ))}
    </ul>
);

const SectionHeading = ({ children }) => (
    <h2 className="text-2xl font-bold text-white mt-10 mb-4">{children}</h2>
);

const JobDescriptionPage = () => {
    const location = useLocation();
    const { jobId } = useParams();
    const job = location.state?.job || companyJobs.find(j => j.id === jobId);

    if (!job) {
        return <Navigate to="/company/careers/search" replace />;
    }

    const aboutParagraphs = Array.isArray(job.about)
        ? job.about
        : job.about
            ? [job.about]
            : [];

    return (
        <div className="bg-black text-white min-h-full p-8 md:p-16">
            <div className="max-w-4xl mx-auto">
                <div className="mb-12">
                    <Link to="/company/careers/search" className="text-neutral-400 hover:text-white transition-colors">
                        &laquo; Back to Careers
                    </Link>
                </div>

                <header className="mb-10 pb-8 border-b border-neutral-800">
                    <h1 className="text-4xl md:text-5xl font-bold">{job.title}</h1>
                    <p className="text-neutral-400 mt-3 text-lg">
                        {job.department ? `${job.department} · ` : ''}{job.location}
                    </p>
                </header>

                {hasItems(job.minimumQualifications) && (
                    <section>
                        <SectionHeading>Minimum qualifications</SectionHeading>
                        <BulletList items={job.minimumQualifications} />
                    </section>
                )}

                {hasItems(job.preferredQualifications) && (
                    <section>
                        <SectionHeading>Preferred qualifications</SectionHeading>
                        <BulletList items={job.preferredQualifications} />
                    </section>
                )}

                {aboutParagraphs.length > 0 && (
                    <section>
                        <SectionHeading>About the job</SectionHeading>
                        <div className="space-y-4 text-neutral-200 leading-relaxed">
                            {aboutParagraphs.map((para, index) => (
                                <p key={index}>{para}</p>
                            ))}
                        </div>
                    </section>
                )}

                {job.reportingNote && (
                    <p className="mt-6 text-sm text-neutral-400 italic">{job.reportingNote}</p>
                )}

                {hasItems(job.responsibilities) && (
                    <section>
                        <SectionHeading>Responsibilities</SectionHeading>
                        <BulletList items={job.responsibilities} />
                    </section>
                )}

                <div className="mt-14">
                    <Link
                        to={`/company/careers/jobs/${job.id}/apply`}
                        state={{ job }}
                        className="bg-white text-black font-semibold py-3 px-8 rounded-md hover:bg-neutral-200 transition-colors"
                    >
                        Apply Now
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default JobDescriptionPage;
